import { SVGProps } from 'react';
const SvgArrowCircleUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM15 11l-3-3m0 0-3 3m3-3v8"
    />
  </svg>
);
export default SvgArrowCircleUp;
